// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"169":"56d19d91","477":"bfa12c72","799":"95188b8d"}[chunkId] + ".css";
};